import Backbone from 'backbone'
import template from './admin-shared-dashboard-links.hbs'
import linksTemplate from '../../dashboards/shared-dashboard-links.hbs'
import linksContext from '../../dashboards/shared-dashboard-links-context'

var ShareDashboard = Backbone.View.extend({

	className: 'share-dashboard',

	tagName: 'form',

	events: {
		'click .back': 'backToSelection'
	},

	initialize: function(options) {
		this.options = options || {}
		this.links = this.options.links
	},

	render: function () {
		var context = linksContext(this.links, this.options.section)
		this.$el.html(template(context)).append(linksTemplate(context))
		return this
	}

})

export default ShareDashboard

ShareDashboard.__filename__ = 'admin/shared-dashboards/admin-shared-dashboard-links.js'
